import { RouteConfig } from 'vue-router'

const BoardList = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardList.vue')
const Home = () => import(/* webpackChunkName: "home" */ '@home/Index.vue')
const HomeMaster = () => import(/* webpackChunkName: "home" */ '@home/views/Master.vue')
const HomeView = () => import(/* webpackChunkName: "home" */ '@home/views/HomeView.vue')
const ProxyView = () => import(/* webpackChunkName: "home" */ '@home/views/ProxyView.vue')
const WebPartView = () => import(/* webpackChunkName: "home" */ '@home/views/WebPartView.vue')
const TestMaster = () => import(/* webpackChunkName: "home" */ '@home/views/TestMaster.vue')
const SearchView = () => import(/* webpackChunkName: "home" */ '@home/views/SearchView.vue')
// const MyPageView = () => import(/* webpackChunkName: "home" */ '@home/views/MyPageView.vue')
const MyPageView = () => import(/* webpackChunkName: "home" */ '@home/views/MyPage/MyPageView.vue')
const RecentArticle = () => import(/* webpackChunkName: "home" */ '@home/views/RecentArticleView.vue')
const PopupMaster = () => import('@home/views/PopupViewMaster.vue')
const PopupNoticeView = () => import('@home/views/NoticePopup/NoticePreviewView.vue')
const WebpartPersonal = () => import('@home/views/WebpartPersonalView.vue')
const ModalMaster = () => import(/* webpackChunkName: "board" */ '@board/views/ModalMaster.vue')
const BoardWrite = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardWrite.vue')

const BoardRead = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardRead.vue')

const ReportEmail = () => import('@/modules/home/components/KyoboBook/ReportEmail/ReportEmail.vue')
const CleanDesk = () => import('@/modules/home/components/KyoboBook/CleanDesk/CleanDesk.vue')
const PurchaseHistory = () => import('@/modules/home/components/KyoboBook/PurchaseHistory/PurchaseHistory.vue')
const AttendanceManageView = () => import('@/modules/home/views/AttendanceManage/AttendanceManageView.vue')

const routes: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
        children: [
            {
                path: '',
                component: HomeMaster,
                children: [
                    {
                        path: '',
                        component: HomeView,
                        name: 'Home',
                    },
                    {
                        path: 'personal',
                        name: 'webpart-personal',
                        component: WebpartPersonal
                    },
                    {
                        path: 'mypage',
                        component: MyPageView,
                        // props: (route) => ({ query: {name: 'MYPAGE'} }),
                        name: 'MyPage',
                        children: []
                    },
                    {
                        path: 'proxy',
                        name: 'menu-proxy',
                        component: ProxyView,
                        children: [
                        ],
                    },
                    {
                        path: 'recentarticle',
                        name: 'recent-article',
                        component: RecentArticle
                    },
                    {
                        path: 'search',
                        name: 'total-search',
                        component: SearchView,
                        children: [
                            {
                                path: 'modal',
                                component: ModalMaster,
                                children: [
                                    {
                                        path: 'write',
                                        component: BoardWrite,
                                    },
                                    {
                                        path: 'read',
                                        component: BoardRead,
                                    },
                                ],
                            }
                        ]
                    },
                    {
                        path: 'WebPart',
                        component: WebPartView,
                    },
                    {
                        path: 'attendancemanage',
                        name: 'attendance-manage',
                        component: AttendanceManageView,
                    }
                ],
            },
            {
                path: 'popup',
                component: PopupMaster,
                children: [
                    {
                        path: 'notice',
                        name: 'popup-notice',
                        component: PopupNoticeView,
                        children: [

                        ]
                    }
                ]
            },
            {
                path: 'report',
                name: 'report-email',
                component: ReportEmail
            },
            {
                path: 'cleandesk',
                name: 'clean-desk',
                component: CleanDesk
            },
            {
                path: 'purchase',
                name: 'purchase-history',
                component: PurchaseHistory
            },
        ],
    }
]
export default routes
